import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../../store/selectors/text-submission-drawer.selectors'
import { Collapse } from 'antd'
import { getAnswerByRubric } from '../../../../../../../../utils/question.helper'
import { textSubmissionDrawerActions } from '../../../../../../../../store/slices/text-submission-drawer.slice'

const QuestionRubricCollapse = ({ question, answers, ContentComponent }) => {
    const expandedQuestionRubricIds = useSelector(textSubmissionDrawerSelectors.expandedQuestionRubricIds)
    const dispatch = useDispatch()

    const questionRubrics = question.questionRubrics || []

    const items = questionRubrics.map(questionRubric => {
        const answer = getAnswerByRubric(answers, questionRubric, question)
        return {
            key: questionRubric.id,
            label: questionRubric.name || `Rubric ${questionRubric.id}`,
            children: <ContentComponent question={question} questionRubric={questionRubric} answer={answer} />,
        }
    })

    const onChange = expandedKeys => {
        const numericKeys = expandedKeys.map(Number)
        dispatch(textSubmissionDrawerActions.setExpandedQuestionRubricIds(numericKeys))
    }

    return <Collapse activeKey={expandedQuestionRubricIds} onChange={onChange} items={items} size='small' bordered={false} />
}

export default QuestionRubricCollapse

